// @flow
import { makeGetRequest } from '../../utils'

import type { Genres } from '../../types/genres'
import type { ResponseAPI } from '../../types/api'

export const getTvShowGenres = (domain: string, serviceId: string): Promise<ResponseAPI<Genres>> =>
  makeGetRequest(`${domain}/client/api/servicespec/${serviceId}/tv-show/genres`)
